import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { useSelector, useDispatch } from "react-redux";
import { getListNhanVay, updateDataSearch } from "../../actions/NhanVay/";
import { formatDayMonth } from "utils/formatDate";
import { currentDate, convertDate } from "utils/formatDate";

export const ModalTimKiemNangCao = (props) => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchNhanVay);
  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateDropdown = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const onChangeDate = (field) => (evt) => {
    updateState(field, formatDayMonth(evt));
  };

  const onSearchNangCao = () => {
    props.onSearch();
    props.onHide();
  };
  // convert sự kiện tìm kiếm từ ngày đến ngày
  var dateFrom = currentDate();
  if (dataSearch.dateFrom === "01/01/2001") dateFrom = "";
  else dateFrom = dataSearch.dateFrom;
  var dateTo = currentDate();
  if (dataSearch.dateTo === "01/01/4000") dateTo = "";
  else dateTo = dataSearch.dateTo;
  dateTo = convertDate(dateTo);
  dateFrom = convertDate(dateFrom);
  return (
    <Modal
      {...props}
      size="modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="fade modal-new modal fade text-left modal show"
    >
      <Modal.Header>
        <h4 class="modal-title  color7-bold" id="myModalLabel16">
          <span class="btn-icon-right">
            <img src="/app-assets/images/icon-tim-kiem-nang-cao.png" />
          </span>
          Bộ lọc nâng cao
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <div class="row repeater-default">
          <div class="form-group mb-1 col-sm-12 col-md-12">
            <label for="email-addr" className="color7-bold">
              Tìm kiếm
            </label>
            <br />
            <input
              type="text"
              className="form-control input-sm"
              value={dataSearch.customerName}
              onChange={updateTextValue("customerName")}
              placeholder="Tên, sđt chủ nợ ..."
            />
          </div>
        </div>
        <div class="row repeater-default">
          <div class="form-group mb-1 col-sm-12 col-md-6">
            <label for="tel-input">Từ ngày</label>
            <br />
            <DateTimePicker
              value={dateFrom}
              onChange={onChangeDate("dateFrom")}
              //onKeyDown={onKeyDownDate}
              placeholder="Từ ngày"
            ></DateTimePicker>
          </div>
          <div class="form-group mb-1 col-sm-12 col-md-6">
            <label for="tel-input">Đến ngày</label>
            <br />
            <DateTimePicker
              value={dateTo}
              onChange={onChangeDate("dateTo")}
              placeholder="Đến ngày"
            ></DateTimePicker>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="text-right">
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={props.onHide}
        >
          <span>
            <i class="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </button>
        <button
          type="button"
          class="btn btn-new-main btn-checknew"
          onClick={(e) => onSearchNangCao()}
        >
          <span>
            <i class="mdi mdi-magnify"></i>
          </span>{" "}
          Tìm kiếm
        </button>
      </Modal.Footer>
    </Modal>
  );
};
